export default "/assets/images/two-size-mila.3509d0fc7a50ce46.png";